import Field from "components/shared/field";
import { ymEvent } from "helpers/system";
import React, { useState } from "react";
import { applyNote } from "sources/books/trucks";
import { resetCache } from "sources/tripPlanning";

export default function NoteForm(props) {
    const [comment, setComment] = useState(props.note);
    const [loading, setLoading] = useState(false);
    const saveNote = () => {
        setLoading(true);
        applyNote({ id: props.carId, note: comment }).then((res) => {
            if (res) {
                props.setNote(comment);
                ymEvent("TripPlanningCarDetailsUsed");
                resetCache();
            }
            setLoading(false);
            props.back();
        });
    };

    return (
        <div className={loading ? "loading" : ""}>
            <Field
                textarea
                onChange={({ value }) => setComment(value)}
                value={comment}
                inputProps={{
                    name: "comment",
                    className: "form-control form-control-sm",
                }}
            />
            <div className="btn btn-brand mt-2" onClick={saveNote}>
                Сохранить
            </div>
        </div>
    );
}
